<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 .75C18.213.75 23.25 5.787 23.25 12S18.213 23.25 12 23.25.75 18.213.75 12 5.787.75 12 .75Z"
      fill="#5AA4FF"
      stroke="#000"
      stroke-width="1.5"
    />
    <path
      d="M17.25 15.5V12a5.25 5.25 0 1 0-10.5 0v3.5m1.458 1.75a1.46 1.46 0 0 1-1.458-1.458v-1.167a1.458 1.458 0 0 1 2.917 0v1.167c0 .805-.653 1.458-1.459 1.458m7.584 0a1.46 1.46 0 0 1-1.459-1.458v-1.167a1.458 1.458 0 0 1 2.917 0v1.167c0 .805-.653 1.458-1.458 1.458"
      stroke="#000"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
